import type { Event } from '@cocoonspace/sdk-js/types/event'
import { dateTimeUtils } from '@cocoonspace/shared/utils/date-time-utils'

const DEFAULT_HOURS = 48

export const isLastMinuteBooking = (
	events: Pick<Event, 'start' | 'day'>[],
	hours = DEFAULT_HOURS,
) => {
	const now = dateTimeUtils()
	const nextHours = now.add(hours, 'hours')

	return events.some((event) => {
		const eventDateTime = dateTimeUtils(`${event.day} ${event.start}`)

		if (eventDateTime.isBefore(now)) {
			return true
		}
		return eventDateTime.isBetween(now, nextHours, 'minutes', '[]')
	})
}
